import type { WhoAmIResponse } from '~/interfaces';
import { alwaysJsonParser } from '~/util/fetch';

export const whoAmI = (): Promise<WhoAmIResponse> => {
  return fetch(`${REPLACE_AUTH_API}/api/whoami`, {
    credentials: 'include',
  })
    .then(alwaysJsonParser<WhoAmIResponse>)
    .catch(() => ({}) as WhoAmIResponse);
};
